export const environment = {
  production: false,

  HOST: {
    // FAST_API_URL: 'http://hire.api.localhost:8000/api/v1',
    FAST_API_URL: 'https://api.hire.exam.ly/api/v1',
    // HIRE_GENAI_URL: 'http://localhost:8080',
    HIRE_GENAI_URL: 'https://hire.genai.exam.ly/api/v1',
    HIRE_PULSE_URL: 'https://hire.pulse.exam.ly/api/v1',
    HOST_API_URL: 'https://api.examly.io/api',
    SOCKET_LINK: 'wss://0i8kb3kr78.execute-api.us-east-1.amazonaws.com/dev',
    TINYMCE_API_KEY: 'koicr52xjd7d0dqcqe5z7blu7y080mshhoedfdhe4zmvn3b4',
    // NeoAgents AI Interview
    NEOAGENTS_WS_URL: 'wss://agents.hire.exam.ly/api/v1',
    // NEOAGENTS_WS_URL: 'ws://localhost:8001/api/v1',
    JITSI_DOMAIN: '8x8.vc',
  },
  MIXPANEL_TOKEN: 'ba3ad7f0dd9c98fa1140f61e92d32e3b',
  SENTRY_DSN: 'https://ad9f87d6737529fb109faad1507692ff@o4510164321107968.ingest.us.sentry.io/4510418126569472',

  RECAPTCHA: {
    SITE_KEY: '6LdoWbsrAAAAADJnb0D6ULRHSlU-XaRQXbpteFn6'
  },
  CRISP: {
    WEBSITE_ID: '' // disabled in dev
  }
};